import { ButtonProps } from "@/types/button";
import { FC } from "react";
const Button: FC<ButtonProps> = ({
  title,
  color,
  disabled,
  onClick,
  image,
  submit,
}) => {
  return (
    <button
      type={submit}
      disabled={disabled}
      onClick={onClick}
      className={`button__auth button__auth--${color}`}
    >
      {disabled && <span className="button__loader" />}

      {title}
      {image && <img src={image} alt="" />}
    </button>
  );
};

export default Button;
